<template>
  <div class="main">
    <SideBar />
    <div class="main__content">
      <slot />
      <PlanExpiredDialog v-if="isAuthenticated" />
      <OutOfStorageDialog v-if="isAuthenticated" />
      <PortalTarget
        name="mainContent"
        multiple
        :style="{ zIndex: 'var(--z-index-modal-level-2-overlay)' }"
      />
    </div>
    <SettingsDialog v-if="isAuthenticated" />
    <PortalTarget
      name="fullscreen"
      multiple
    />
  </div>
</template>

<script lang="ts">
export default {
  name: 'MainLayout',
}
</script>

<script lang="ts" setup>
import { computed, watch } from 'vue'

import OutOfStorageDialog from '@/modules/Billing/OutOfStorageDialog.vue'
import PlanExpiredDialog from '@/modules/Billing/PlanExpiredDialog.vue'
import { useMembershipLoader } from '@/composables/useMembershipLoader'
import { useAuthStore } from '@/modules/Auth/useAuthStore'

import SettingsDialog from './SettingsDialog/SettingsDialog.vue'
import SideBar from './Sidebar/Sidebar.vue'
import { useTeamStore } from '@/pinia/useTeamStore'
import { useTeamProperties } from '@/modules/Classes/useTeamProperties'

const authStore = useAuthStore()

const isAuthenticated = computed(() => authStore.authenticated)

useMembershipLoader()

const teamStore = useTeamStore()
const teamPropertiesStore = useTeamProperties()

watch(
  () => teamStore.currentTeam,
  () => {
    if (!teamStore.currentTeam?.slug) {
      return
    }
    teamPropertiesStore.fetchProperties(teamStore.currentTeam?.slug)
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;
  color: var(--color-text-default);

  &__content {
    position: relative;
    background: var(--color-surface-tertiary);
    position: relative;
    height: 100vh;

    // allows the container to shrink when needed
    min-width: 0;
  }
}
</style>
